import { render, staticRenderFns } from "./LatestNewsPost.vue?vue&type=template&id=41b7d3e3&scoped=true&"
import script from "./LatestNewsPost.vue?vue&type=script&lang=js&"
export * from "./LatestNewsPost.vue?vue&type=script&lang=js&"
import style0 from "./LatestNewsPost.vue?vue&type=style&index=0&id=41b7d3e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b7d3e3",
  null
  
)

export default component.exports